import { takeLatest, call, put } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { PremiumAction } from "../actions";
import * as premiumApi from "../api/premium";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherPremium() {
  yield takeLatest(types.PREMIUM_INIT_REQUEST, worker);
  yield takeLatest(types.PREMIUM_CALCULATE_PRICE_REQUEST, calculatePriceWorker);
  yield takeLatest(types.PREMIUM_USE_WALLET_REQUEST, useWalletWorker);
  yield takeLatest(types.PREMIUM_USE_PROMO_CODE_REQUEST, usePromoCodeWorker);
  yield takeLatest(types.PREMIUM_TRANSACTION_LIST_REQUEST, getListWorker);
  yield takeLatest(
    types.PREMIUM_TRANSACTION_LIST_BY_PROJECT_REQUEST,
    getListByProjectWorker
  );
  yield takeLatest(types.PREMIUM_PAY_REQUEST, store);
  yield takeLatest(types.PREMIUM_PROMO_CODE_REQUEST, promoCode);
}

function fetchInit(type, project_id) {
  return premiumApi.init(type, project_id);
}

function* worker(action) {
  try {
    const response = yield call(
      fetchInit,
      action.action_type,
      action.project_id
    );
    yield put(PremiumAction.getSuccess(response.data.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(PremiumAction.getFailure());
  }
}

function calculatePrice(data, projectId) {
  return premiumApi.calculatePrice(data, projectId);
}

function* calculatePriceWorker(action) {
  try {
    const response = yield call(calculatePrice, action.data, action.projectId);
    yield put(PremiumAction.calculatePriceSuccess(response.data.data, action.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(PremiumAction.calculatePriceFailure(action.data));
  }
}

function useWallet(data, projectId) {
  return premiumApi.calculatePrice(data, projectId);
}

function* useWalletWorker(action) {
  try {
    const response = yield call(useWallet, action.data, action.projectId);
    yield put(PremiumAction.useWalletSuccess(response.data.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(PremiumAction.useWalletFailure());
  }
}

function usePromoCode(data, projectId) {
  return premiumApi.calculatePrice(data, projectId);
}

function* usePromoCodeWorker(action) {
  try {
    const response = yield call(usePromoCode, action.data, action.projectId);
    yield put(PremiumAction.usePromoCodeSuccess(response.data.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
    error.response.data.message.forEach(message => {
      toastr.error(" ", message.toString());
    });
    yield put(PremiumAction.usePromoCodeFailure());
  }
}

function fetchTransactionList() {
  return premiumApi.getList();
}

function* getListWorker() {
  try {
    const response = yield call(fetchTransactionList);
    yield put(PremiumAction.getListSuccess(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(PremiumAction.getListFailure(error));
  }
}

function fetchTransactionListByProject() {
  return premiumApi.getByProject();
}

function* getListByProjectWorker() {
  try {
    const response = yield call(fetchTransactionListByProject);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(PremiumAction.getListByProjectSuccess(response.data.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(PremiumAction.getListByProjectFailure(error));
  }
}

function fetchStore(data, project_id) {
  return premiumApi.payStore(data, project_id);
}

function* store(action) {
  try {
    const response = yield call(fetchStore, action.data, action.projectId);
    yield put(PremiumAction.payStoreSuccess(response.data));
    if(response.data.redirect_url){
      window.location.href = response.data.redirect_url;
    }
    else {
      window.location.href = "/";
    }
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(PremiumAction.payStoreFailure());
  }
}

function fetchPromoCode() {
  return premiumApi.getPromoCode();
}

function* promoCode() {
  try {
    const response = yield call(fetchPromoCode);
    yield put(PremiumAction.getPromoCodeSuccess(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(PremiumAction.getPromoCodeFailure());
  }
}
